import {Injectable} from '@angular/core';
import {UserIdleService} from 'angular-user-idle';
import {switchMap, take} from 'rxjs';
import {AuthenticationService} from '~local/app/core/services/authentication.service';
import {RouterActionsService} from '~local/app/shared/services/router-actions.service';
import {DialogService} from '~shared/ng/services/dialog/dialog.service';
import {DialogBaseComponent} from '~shared/ng/components/dialog/base/dialog.base.component';

@Injectable()
export class IdlerService {
    protected inactivityDialogRef: DialogBaseComponent | null = null;

    public constructor(
        protected readonly authenticationService: AuthenticationService,
        protected readonly routerActionsService: RouterActionsService,
        protected readonly userIdleService: UserIdleService,
        protected readonly dialogService: DialogService,
    ) {
        this.userIdleService.onTimerStart()
            .subscribe($count => {
                if ($count === 1) {
                    import('../components/inactivity-dialog/inactivity-dialog.component').then(c => {
                        this.inactivityDialogRef = this.dialogService.create(c.InactivityDialogComponent);
                        this.inactivityDialogRef.onClose$
                            .pipe(take(1))
                            .subscribe(res => {
                                if (res && res.continue) {
                                    this.userIdleService.resetTimer();
                                }
                                this.inactivityDialogRef = null;
                            });

                    });
                }
            });

        this.userIdleService.onTimeout().pipe(
            switchMap(() => {
                return this.authenticationService.doLogout$();
            }),
            switchMap(() => {
                return this.routerActionsService.reload(true);
            }),
        ).subscribe(() => {
            if (this.inactivityDialogRef) {
                this.inactivityDialogRef.close();
            }
        });

        this.authenticationService.isAuthorized$
            .subscribe($authorized => {
                if ($authorized) {
                    this.userIdleService.startWatching();
                } else {
                    this.userIdleService.resetTimer();
                    this.userIdleService.stopWatching();
                }
            });
    }
}
